import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Clipboard20 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={20}
    contrast={contrast}
    className={className}
  >
    <path d='M8.5 9.75H15V8.25H8.5V9.75Z' fill='currentColor' />
    <path d='M15 14.75H8.5V13.25H15V14.75Z' fill='currentColor' />
    <path
      d='M6 15C6.55228 15 7 14.5523 7 14C7 13.4477 6.55228 13 6 13C5.44772 13 5 13.4477 5 14C5 14.5523 5.44772 15 6 15Z'
      fill='currentColor'
    />
    <path
      d='M7 9C7 9.55229 6.55228 10 6 10C5.44772 10 5 9.55229 5 9C5 8.44771 5.44772 8 6 8C6.55228 8 7 8.44771 7 9Z'
      fill='currentColor'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M7 0.25C6.41093 0.25 6.25 0.768637 6.25 1.25H2.5C1.80964 1.25 1.25 1.80965 1.25 2.5V18.5C1.25 19.1904 1.80964 19.75 2.5 19.75H17.5C18.1904 19.75 18.75 19.1904 18.75 18.5V2.5C18.75 1.80964 18.1904 1.25 17.5 1.25H13.75C13.75 0.768637 13.5891 0.25 13 0.25H7ZM13.75 2.75V4C13.75 4.41421 13.4142 4.75 13 4.75H7C6.58579 4.75 6.25 4.41421 6.25 4V2.75H2.75V18.25H17.25V2.75H13.75ZM7.75 3.25V1.75H12.25V3.25H7.75Z'
      fill='currentColor'
    />
  </Svg>
);

Clipboard20.displayName = 'Clipboard20';
export default Clipboard20;
